import { mainSiteUrl } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden h-[350px] md:h-[500px]">
            <img
              src="https://readdy.ai/api/search-image?query=Young%20professional%20woman%20in%20modern%20glass%20office%20working%20on%20dual%20monitor%20setup%20with%20colorful%20spreadsheets%20and%20Chinese%20marketplace%20websites%20visible%2C%20surrounded%20by%20opened%20product%20boxes%20and%20shipping%20materials%2C%20bright%20afternoon%20daylight%2C%20contemporary%20tech%20startup%20workspace%20aesthetic%2C%20genuine%20focused%20expression%2C%20clean%20modern%20interior%20with%20plants%2C%20productivity%20and%20e-commerce%20lifestyle%20photography&width=1000&height=1200&seq=compare-v2&orientation=portrait"
              alt="YOYBUY Spreadsheet сравнение методов заказа"
              title="YOYBUY Spreadsheet vs обычные заказы"
              className="w-full h-full object-cover object-center"
            />
          </div>

          <div>
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-50 rounded-full">
              Сравнение
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-2">
              YOYBUY Spreadsheet vs{' '}
              <span className="text-primary-500">обычные заказы</span>
            </h2>
            <p className="text-sm text-foreground-500 mb-8 leading-relaxed">
              Посмотрите, насколько проще и безопаснее заказывать товары из Китая через YOYBUY Spreadsheet по сравнению с ручным оформлением заказов.
            </p>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Метод</th>
                    <th className="text-center py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Удобство</th>
                    <th className="text-center py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Ошибки</th>
                    <th className="text-center py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Скорость</th>
                    <th className="text-center py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Контроль</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="py-4 px-4">
                      <span className="text-sm font-bold text-primary-600">YOYBUY Spreadsheet</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary-50 text-primary-500 text-xs font-bold">✓</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="text-sm text-foreground-600">Низкие</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="text-sm text-foreground-600">Быстро</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="text-sm text-foreground-600 font-semibold text-primary-600">Полный</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 px-4">
                      <span className="text-sm text-foreground-500">Ручной заказ</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-foreground-100 text-foreground-400 text-xs font-bold">✗</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="text-sm text-foreground-500">Высокие</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="text-sm text-foreground-500">Медленно</span>
                    </td>
                    <td className="text-center py-4 px-4">
                      <span className="text-sm text-foreground-500">Ограниченный</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap no-underline"
              >
                Перейти к YOYBUY
                <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}